import React, { useState, useEffect } from 'react'
import { PaginationProps } from './types'
import { useTranslation } from 'react-i18next'
import { getDataForPage } from './utils'
import './Scss/pagination.scss';

const Pagination = ({
    pageSize = 10,
    paginationRadius = 1,
    ...props
}: PaginationProps) => {
    const { t } = useTranslation()
    const [page, setPage] = useState<number>(1)
    const nrOfPages = Math.ceil(props.totalCount / pageSize)

    const onSelectPage = (clickedPage: number) => {
        setPage(clickedPage)
        const pageData = getDataForPage(clickedPage, pageSize, props.data || [])
        props.onSelectPage(clickedPage, pageData)
    }

    const renderPageButtons = () => {
        const buttons = []
        let hasEllipsisBefore = false
        let hasEllipsisAfter = false

        for (let i = 1; i <= nrOfPages; i++) {
            const isSelected = !!(page === i)
            if (i === 1) {
                buttons.push(
                    <button
                        key={i}
                        className={`pagination__button ${isSelected && 'selected'}`}
                        disabled={isSelected}
                        onClick={() => onSelectPage(i)}
                    >
                        {i}
                    </button>
                )
            } else if (
                i >= page - paginationRadius &&
                i <= page + paginationRadius
            ) {
                buttons.push(
                    <button
                        key={i}
                        className={`pagination__button ${isSelected && 'selected'}`}
                        disabled={isSelected}
                        onClick={() => onSelectPage(i)}
                    >
                        {i}
                    </button>
                )
            } else if (i === nrOfPages && nrOfPages > 1) {
                buttons.push(
                    <button
                        key={i}
                        className={`pagination__button ${isSelected && 'selected'}`}
                        disabled={isSelected}
                        onClick={() => onSelectPage(i)}
                    >
                        {i}
                    </button>
                )
            } else if (
                i > 1 &&
                i < page - paginationRadius &&
                !hasEllipsisBefore
            ) {
                buttons.push(
                    <button
                        key={i}
                        className="pagination__button ellipsis"
                        onClick={() =>
                            onSelectPage(page - paginationRadius - 1)
                        }
                    >
                        ...
                    </button>
                )
                hasEllipsisBefore = true
            } else if (
                i < nrOfPages &&
                i > page + paginationRadius &&
                !hasEllipsisAfter
            ) {
                buttons.push(
                    <button
                        key={i}
                        className="pagination__button ellipsis"
                        onClick={() =>
                            onSelectPage(page + paginationRadius + 1)
                        }
                    >
                        ...
                    </button>
                )
                hasEllipsisAfter = true
            }
        }

        return buttons
    }

    const renderText = () => {
        return (
            <span className={'pagination__page-text'}>
                {t('label.paginationPage', {
                    page: `${page}`,
                    total: `${nrOfPages}`,
                })}
            </span>
        )
    }

    useEffect(() => {
        // If total count changes, always reset to page 1
        onSelectPage(1)
    }, [props.totalCount])

    if (nrOfPages <= 1) {
        return null
    }

    return (
        <div className={'pagination'}>
            <div className={'pagination__page-buttons'}>{renderPageButtons()}</div>
            {renderText()}
        </div>
    )
}

export default Pagination
